exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pic[data-v-7f409828]{text-align:center}.pic__onde[data-v-7f409828]{max-width:771px}.pic__trede[data-v-7f409828]{max-width:634px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7f409828","scoped":true,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ticket/component.vue
// module id = 20e913f7f15a526efa95
// module chunks = 35